export const CASE_TABS = ['overview', 'documents', 'findings', 'pathway', 'report'] as const;
export type CaseTab = (typeof CASE_TABS)[number];

export const CASE_TAB_LABELS: Record<CaseTab, string> = {
  overview: 'Overview',
  documents: 'Documents',
  findings: 'Findings',
  pathway: 'Pathway',
  report: 'Report',
};

/** Tabs that show one run (`?run=`); the overview combines the latest run of each stage. */
export const RUN_TABS: ReadonlySet<CaseTab> = new Set([
  'documents',
  'findings',
  'pathway',
  'report',
]);

/** The case tab a path is on, if any: `/cases/p1/findings` -> `findings`. */
export function tabOf(pathname: string): CaseTab | undefined {
  const last = pathname.replace(/\/+$/, '').split('/').pop();
  return CASE_TABS.find((t) => t === last);
}
